<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Testimonials</h1>
      <ul>
        <li><a class="active" routerLink="/">Home</a></li>
        <li><a>Alumni</a></li>
        <li>Testimonials</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 section-layout">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <alumni-menu></alumni-menu>
        </div>

        <div class="col-lg-8">
          <div class="blog-item">
            <div class="blog-content">
              <h3 class="blog-title">Student Testimonials</h3>
              <div class="blog-desc management-desc">
                Hear from our students and alumni about their experiences at PVKK Degree & P.G College. Their success stories and positive feedback reflect the quality of education and supportive environment we provide.
              </div>
              <div class="blog-desc management-desc">
                "The faculty at PVKK has been incredibly supportive and knowledgeable. The infrastructure and resources provided have greatly enhanced my learning experience. I am grateful for the opportunities to engage in research and develop practical skills that will help me in my career." - Recent Graduate
              </div>
              <div class="blog-desc management-desc">
                "PVKK PG College provided me with excellent academic foundations and practical exposure. The college's focus on overall development of students made it easier for me to transition into my professional career. I highly recommend this institution to anyone seeking quality higher education." - Alumni
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

